module.exports = __webpack_public_path__ + "static/Gago-Frigerio-6b8cc35b3903d2a72275c2429f7bc76d.png";